import React from "react";
import ConfirmDialog from "common_components/confirm_dialog";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import {Workflow} from "common/flowmaster/types/workflow";

type DataAssetLockConfirmDialogProps = {
  dataAsset: Workflow;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

const CannotLockDialog: React.FC<{onClose: () => void; open: boolean}> = ({
  onClose,
  open,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{"Cannot lock workflow"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          At least one input requires a default value, but does not have one.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const DataAssetLockConfirmDialog: React.FC<DataAssetLockConfirmDialogProps> = ({
  dataAsset,
  open,
  onClose,
  onSuccess,
}) => {
  if (
    dataAsset.inputs.values.some(
      input => input.requires_default && !input.has_default,
    )
  ) {
    return <CannotLockDialog onClose={onClose} open={open} />;
  }
  return (
    <ConfirmDialog
      open={open}
      onSuccess={() => onSuccess()}
      onClose={() => onClose()}
      title={`Permanently lock Data Asset \"${dataAsset.name}\"?`}
      description="Data assets cannot be unlocked. Are you sure you want to permanently lock this data asset?"
      okButtonCaption="Yes"
      cancelButtonCaption="No"
    />
  );
};
